import { useMemo } from 'react';

import { MarginPositionStatus } from '@swyftx/margin/build/types';

import { Big } from '@shared/safe-big';

import { useMarginPositions } from 'src/lib/margin/hooks/positions';

const useMarginProfitLossChart = () => {
  const { positions } = useMarginPositions({ status: [MarginPositionStatus.Open] });

  const totalProfitLossAbs = useMemo(() => {
    if (!positions?.length) return Big(0);

    return positions.reduce((prev, curr) => prev.plus(Big(curr.profit || '0').abs()), Big(0));
  }, [positions]);

  return {
    totalProfitLossAbs,
  };
};

export { useMarginProfitLossChart };
